import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withKeys as _withKeys } from "vue"
import _imports_0 from '@/app/ui/assets/svg/close-white.svg'


const _hoisted_1 = { class: "flex justify-center items-center py-6 fixed inset-0 z-70 outline-none focus:outline-none w-screen" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4",
  alt: "close"
}, null, -1)
const _hoisted_3 = { class: "w-full flex items-center justify-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "opacity-50 fixed inset-0 z-60 bg-black" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SplideSlide = _resolveComponent("SplideSlide")!
  const _component_Splide = _resolveComponent("Splide")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: "font-montserrat",
        onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)), ["esc"]))
      }, [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", {
            class: "absolute w-auto bg-gray-lp-500 p-4 rounded-full top-0 right-0 mt-4 mr-10 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
          }, [
            _hoisted_2
          ]),
          _createVNode(_component_Splide, {
            options: {
          rewind: true,
          type: 'fade',
          lazyLoad: 'nearby',
          focus: 'center',
          arrows: _ctx.computedData.length > 1,
          pagination: _ctx.computedData.length > 1,
          start: _ctx.initialIndex,
          classes: {
            prev: 'splide__arrow--prev prev-arrow',
            next: 'splide__arrow--next next-arrow'
          }
        },
            class: "mt-5 w-13/20 md:w-3/4",
            style: `height: ${_ctx.maxHeightDefault - 40}px`
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.computedData, (item, index) => {
                return (_openBlock(), _createBlock(_component_SplideSlide, { key: index }, {
                  default: _withCtx(() => [
                    _createVNode("div", {
                      class: "flex items-center",
                      style: `height: ${_ctx.maxHeightDefault - 70}px`
                    }, [
                      _createVNode("div", _hoisted_3, [
                        (_ctx.getType(item) !== 'pdf')
                          ? (_openBlock(), _createBlock("img", {
                              src: _ctx.displaySrc(index, item),
                              key: _ctx.objectUrls[index] || item.url || index,
                              style: `height: ${_ctx.maxHeightDefault - 70}px`,
                              class: `rounded-lg object-cover rounded-xl items-center justify-center`,
                              alt: item?.image || 'preview'
                            }, null, 12, ["src", "alt"]))
                          : _createCommentVNode("", true)
                      ])
                    ], 4)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["options", "style"])
        ]),
        _hoisted_4
      ], 32))
    : _createCommentVNode("", true)
}